import { useMutation, useQueryClient } from '@tanstack/react-query';
import clientApi from '~/clientApi';
import { AGENCY_SAVED_LISTS, SAVED_LISTS } from '~/queries/keys';

interface CreateListPostParameters {
  name?: string;
  saved?: boolean;
  creatorIds?: string[];
  enabledControls?: string[];
}

const createList = async ({
  name,
  saved = false,
  creatorIds = [],
  enabledControls = [],
}: CreateListPostParameters) => {
  const list = await clientApi.savedLists.create({
    name,
    saved,
    enabledControls,
    _isImpersonatingDisabled: true,
  });

  if (list.id && creatorIds.length) {
    await clientApi.savedLists.addCreators({
      id: list.id,
      creatorIds,
      _isImpersonatingDisabled: true,
    });
  }

  return list;
};

interface UseCreateListProps {
  disableInvalidation?: boolean;
}

export const useCreateList = ({
  disableInvalidation = false,
}: UseCreateListProps = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ name, saved, creatorIds, enabledControls }: CreateListPostParameters) =>
      createList({ name, saved, creatorIds, enabledControls }),
    {
      onSuccess: () => {
        if (disableInvalidation) return;

        queryClient.invalidateQueries({
          queryKey: [SAVED_LISTS],
        });
        queryClient.invalidateQueries({
          queryKey: [AGENCY_SAVED_LISTS],
        });
      },
    },
  );
};
